module.exports = __webpack_public_path__ + "static/media/rgb.098e46cd.png";